var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#28673C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9494 24.0368C11.7305 23.9268 11.4902 23.8889 11.2518 23.9453C10.4413 24.136 9.13368 24.462 8.18213 24.7013C7.64117 24.8375 7.14886 24.3559 7.27437 23.813C7.5108 22.7875 7.83868 21.3612 7.99435 20.648C8.043 20.4262 8.01284 20.1975 7.91652 19.9922C7.34637 18.7712 7 17.4198 7 16.0002C7 10.4885 12.0214 6.09267 17.7151 7.16097C21.2926 7.8323 24.1677 10.7083 24.839 14.2849C25.9073 19.9786 21.5115 25 15.9998 25C14.59 25 13.1811 24.6595 11.9494 24.0368Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6009 12.4608C11.2144 13.8541 12.2652 16.0675 14.1138 17.9161C15.9624 19.7648 18.1408 20.7805 19.5341 19.3941L19.6625 19.2656C20.221 18.7081 20.1393 17.7809 19.4923 17.3295C19.2831 17.1845 19.0642 17.0308 18.8316 16.8683C18.3286 16.5151 17.6407 16.5696 17.2058 17.0025L16.9704 17.2361C15.9575 16.6328 15.4438 16.0529 14.7598 15.0255L14.9933 14.7901C15.4253 14.3542 15.4798 13.6663 15.1276 13.1633C14.9641 12.9307 14.8114 12.7118 14.6655 12.5027C14.215 11.8556 13.2878 11.7749 12.7293 12.3324L12.6009 12.4608Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.809d1174a8b2c9807996ba12325ea5c7.svg";
export { ForwardRef as ReactComponent };